var modalWrap = document.querySelector('.modal-wrap');
var modalOverlay = document.querySelector('.modal-wrap .overlay');

// タッチデバイスか非タッチデバイスかを判定
var isTouchDevice = 'ontouchstart' in window;
var clickEventType = 'click';
if (isTouchDevice) {
	clickEventType = 'touchend';
}

// モーダルウィンドウを表示する関数
var openModal = function() {
	if (modalWrap && modalOverlay) {
		modalWrap.classList.add('is-active');
		modalOverlay.classList.add('is-active');
		document.body.style.overflow = 'hidden';
	}
};

// モーダルウィンドウを閉じる関数
var closeModal = function() {
	if (modalWrap && modalOverlay) {
		modalWrap.classList.remove('is-active');
		modalOverlay.classList.remove('is-active');
		document.body.style.overflow = '';
	}
};

// ×ボタン押下時イベント
// jQueryが利用可能であることを前提とします
$(function() {
    if ($('.modal-wrap .modal-btn-close').length && $('.modal-wrap .overlay').length) {
        $('.modal-wrap .modal-btn-close').on(clickEventType, function() {
            closeModal();
        });

        // モーダルウィンドウ以外を押下した際のイベント
        $('.modal-wrap .overlay').on(clickEventType, function() {
            closeModal();
        });
    }

    // open-modalボタンのクリックイベント
    $('.open-modal').on(clickEventType, function() {
        openModal();
    });
});

$(window).on('load', function() {
    
	//カルーセルの初期表示
	slickInitialize();
	if ($('.apply__slider.mynp_01').length) {
		$('.apply__slider.mynp_01').each(function() {
			var _slickTrack = $(this).find('.slick-track'),
				_slickHeight = _slickTrack.outerHeight();

			_slickTrack.css('height', _slickHeight);
		});
	}
	if ($('.apply__slider.mynp_02').length) {
		$('.apply__slider.mynp_02').each(function() {
			var _slickTrack = $(this).find('.slick-track'),
				_slickHeight = _slickTrack.outerHeight();

			_slickTrack.css('height', _slickHeight);
		});
	}
});

$('.apply__slider').slick({
	slidesToShow: 3,
	autoplay: false,
	speed: 800,
	swipeToSlide: true,
	infinite: false,
	dots: true,
	variableWidth: true,
	responsive: [{
		breakpoint: 768,
		settings: {
			slidesToShow: 1,
			centerMode: true,

			variableWidth: true,
		}
	}]
});

document.addEventListener('DOMContentLoaded', function() {
    const modalOverlay = document.getElementById('modal-overlay');
    const modal = document.getElementById('modal');
    const closeButton = document.getElementById('modal-close-button');
    const openButtons = document.querySelectorAll('.modal-open-button');
    const modalContentBlocks = document.querySelectorAll('.modal-content-block');

    const openModal = (modalId) => {
        modalContentBlocks.forEach(block => {
            block.classList.remove('is-active');
        });

        const targetModal = document.getElementById(modalId);
        if (targetModal) {
            targetModal.classList.add('is-active');
        }

        modalOverlay.classList.add('is-visible');
    };

    const closeModal = () => {
        modalOverlay.classList.remove('is-visible');
    };

    openButtons.forEach(button => {
        button.addEventListener('click', (event) => {
            event.preventDefault(); // aタグのデフォルトの挙動をキャンセル
            const modalId = button.getAttribute('data-modal-id');
            openModal(modalId);
        });
    });

    if (closeButton) {
        closeButton.addEventListener('click', closeModal);
    }

    if (modalOverlay) {
        modalOverlay.addEventListener('click', (event) => {
            if (event.target === modalOverlay) {
                closeModal();
            }
        });
    }

    if (modal) {
        modal.addEventListener('click', (event) => {
            event.stopPropagation();
        });
    }
});
